<!---
 -->
<form nz-form [formGroup]="form" (ngSubmit)="submit()">
  <input class="cdk-visually-hidden" formControlName="id" autocomplete="one-time-code" id="my-non-writable-field" name="somethingthatyoushouldnotfill" />
  <button
    nz-button
    nzDanger
    [nzLoading]="$loading | async"
    [disabled]="!form.valid || ($loading | async)"
    nz-popconfirm
    nzPopconfirmTitle="Wirklich löschen?"
    [nzIcon]="DeleteIcon"
    (nzOnConfirm)="submit()"
  >
    <i nz-icon nzType="delete" nzTheme="outline" style="color: red"></i>
    Löschen
    <ng-template #DeleteIcon>
      <i nz-icon nzType="delete" nzTheme="outline" style="color: red"></i>
    </ng-template>
  </button>
</form>
